
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/usage",
      function () {
        return require("private-next-pages/usage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/usage"])
      });
    }
  